import { Divider } from '@mui/material';

export const TyrioInputDivider = () => {
  return (
    <div>
      <Divider />
    </div>
  );
};
